import { render, staticRenderFns } from "./PagesInTheEditionCard.vue?vue&type=template&id=22609123&scoped=true"
import script from "./PagesInTheEditionCard.vue?vue&type=script&lang=js"
export * from "./PagesInTheEditionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22609123",
  null
  
)

export default component.exports